// cSpell:ignore AIzaSyAIwxmvex_by8rHyvFZGDRmvKFlQPwUQ7o
const FirebaseConfig = {
  apiKey: 'AIzaSyDQ-YyeHVO49pYoroXw9p9U9meKLlq2RMY',
  authDomain: 'squares-4fef3.firebaseapp.com',
  projectId: 'squares-4fef3',
  storageBucket: 'squares-4fef3.firebasestorage.app',
  messagingSenderId: '852747073073',
  appId: '1:852747073073:web:6f6ceebfb05154c2218710',
  measurementId: 'G-M0VVBDM3HC',
};

export { FirebaseConfig as default };
